
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import PageHeading from "@/components/PageHeading.vue";
import { ViewAnalytics } from "@/mixins";
import { ApplicationModule, getStoreModule, SessionModule } from "@/store";
import { MetadataKeys } from "@/types";

@Component({
  components: {
    PageHeading,
  },
})
export default class PayWall extends mixins(ViewAnalytics) {
  private applicationStore!: ApplicationModule;
  private sessionStore!: SessionModule;

  // Override for PageTitle mixin
  pageName = "Benefit Not Included | Vignette";

  created(): void {
    this.applicationStore = getStoreModule(ApplicationModule, this.$store);
    this.sessionStore = getStoreModule(SessionModule, this.$store);
  }

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAYWALLED_CONTENT_STATUS, "Behind the Paywall");
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Landing Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Vignette");
    this.pushPageViewEvent();
  }
}
